import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import EngineeringKpi from "./kpi";
import Timelines from "./timeLines";
import AgingAnalysis from "./agingAnalysis";
import EngineeringApprovals from "./approvals";
import CriticalAnalysis from "./criticalDrawings";
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import { useParams } from "react-router-dom";
import EngineeringIEStatusKpi from "./kpiIEStatus";
import { enterpriseTokens } from "styles/theme";

const EngineeringDashboard = () => {

    const { projectId } = useParams();

    const { data: engineeringData } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });

    return (
        <>
            <Grid container spacing={"10px"} sx={{ p: 0, pb: 6 }}>

                <Grid size={12} sx={{ bgcolor: "#fff", p: 2, pt: 2 }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: { xs: "column", md: "row" },
                                gap: 1,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: { xs: "18px", sm: "32px", md: "36px" },
                                    lineHeight: { xs: "16px", md: "48px" },
                                    color: "#252C32",
                                    fontFamily: "Outfit, sans-serif",
                                }}
                            >
                                Engineering Delivery
                            </Typography>
                        </Box>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: '14px',
                                lineHeight: "24px",
                                color: "#252C32",
                                fontFamily: "Outfit, sans-serif",
                            }}
                        >
                            Monitor drawing readiness, approval flow, ageing, and critical engineering commitments.
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={12} sx={{ px: 2 }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            pb: 0.75,
                            borderBottom: `1px solid ${enterpriseTokens.lineSoft}`,
                            "& .MuiTypography-root": { fontSize: "12px", color: enterpriseTokens.muted },
                        }}
                    >
                        <ProjectLastUpdatedOn date={engineeringData?.engineering} />
                    </Box>
                </Grid>
                <Grid container columnSpacing={1.5} rowSpacing={1.5} sx={{ px: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <EngineeringKpi />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <EngineeringIEStatusKpi />
                    </Grid>
                    
                    <Grid size={{ sx: 12, md: 7 }} >
                        <Box sx={{
                            background: "#fff",
                            borderRadius: "3px",
                            p: 0,
                            boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                            border: "1px solid #E2E8F0",
                            overflow: "hidden",
                            height: "100%"
                        }}>
                            <Timelines />
                        </Box>
                    </Grid>
                    {/* <Grid size={{ xs: 12, md: 5 }} >
                        <EngineeringApprovals />
                    </Grid> */}
                    
                    <Grid size={{ sx: 12, md: 5 }} >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 1.5,
                                height: "100%",
                            }}
                        >
                            <Box sx={{
                                background: "#fff",
                                borderRadius: "3px",
                                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                                border: "1px solid #E2E8F0",
                                overflow: "hidden",
                                flex: 1,
                            }}>
                                <EngineeringApprovals />
                            </Box>

                            <Box sx={{
                                background: "#fff",
                                borderRadius: "3px",
                                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                                border: "1px solid #E2E8F0",
                                overflow: "hidden",
                                flex: 2,
                            }}>
                                {/* <AgingAnalysis /> */}
                                <CriticalAnalysis />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>


            </Grid >
        </>
    );
};

export default EngineeringDashboard;
